module.exports = __webpack_public_path__ + "img/kefu_logo.9c308a55.png";